export const dpsEnvironments = {
    // environment 'none' disables the service
    none: '',
    prod: 'https://analytics.chase.com/events/analytics/public/v1/cc.gif',
    qap1: 'https://qap1-analytics.chase.com/events/analytics/public/v1/cc.gif',
    qap2: 'https://qap2-analytics.chase.com/events/analytics/public/v1/cc.gif',
    qap3: 'https://qap3-analytics.chase.com/events/analytics/public/v1/cc.gif',
    qap4: 'https://qap4-analytics.chase.com/events/analytics/public/v1/cc.gif',
    qap5: 'https://qap5-analytics.chase.com/events/analytics/public/v1/cc.gif',
};
//# sourceMappingURL=dpsEnvironments.js.map